import React, { useState, useEffect } from 'react';
import '../styles/GirlsHostel.css';
import pic1 from "../assets/cctv-camera .png";
import pic2 from "../assets/comfort .png";
import pic3 from "../assets/nutrition .png";
import hostel from "../assets/hostel5.webp";
import hostel1 from "../assets/hostel2.webp";
import hostel2 from "../assets/hostel4.webp";
import hostel3 from "../assets/hostel3.webp";

const GirlsHostel = () => {
    const [isVisible, setIsVisible] = useState(false);
            
              useEffect(() => {
                setIsVisible(true);
              }, []);
  const [currentImageSlide, setCurrentImageSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  // Slider Images Only
  const sliderImages = [
    hostel,
    hostel1,
    hostel2,
    hostel3,
  
  ]
  // All Facilities - Only 3 Available
  const facilities = [
    {
      id: 1,
      name: 'Safe & Secure',
      description: 'Round-the-clock security with CCTV surveillance and trained security personnel. Strict entry protocols and visitor management system ensure complete safety and peace of mind for students and parents.',
      icon: pic1,
    },
    {
      id: 2,
      name: 'Comfortable Living',
      description: 'Well-furnished rooms with modern amenities and comfortable beds. Spacious study areas, recreational zones, and common rooms provide a home-like environment for holistic development.',
      icon: pic2,
    },
    {
      id: 3,
      name: 'Nutritious Food',
      description: 'Hygienic mess facility serving healthy and balanced meals. Special attention to dietary requirements with menu planned by nutritionists to ensure proper nourishment and growth.',
      icon: pic3,
    }
  ];

  // Auto-play slider
  useEffect(() => {
    if (!autoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay, sliderImages.length]);

  const nextSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const prevSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const goToImageSlide = (index) => {
    setAutoPlay(false);
    setCurrentImageSlide(index);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <>
       {/* Hero Banner */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">GIRLS HOSTEL</h1>
          </div>
        </div>
      </section>

      {/* Main Girls Hostel Section */}
      <section className="gh-main-section" id="gh-hostel-main">
        {/* About & Slider Container - Side by Side */}
        <div className="gh-about-slider-container">
          {/* Left - About Section */}
          <div className="gh-about-wrapper">
            <div className="gh-description-block">
              <h2 className="gh-section-title">About <span className="gh-title-highlight">Girls Hostel</span></h2>
              <p className="gh-description-text">
                Our Girls Hostel provides a safe, comfortable, and nurturing environment for female students. 
                We understand the importance of creating a secure home away from home where students can focus on 
                their studies while developing independence and life skills. With dedicated wardens, modern facilities, 
                and a supportive community, our hostel ensures that every student feels protected, valued, and empowered.
              </p>
            </div>
          </div>

          {/* Right - Image Slider */}
          <div className="gh-slider-wrapper">
            <div className="gh-image-carousel">
              {/* Image Display */}
              <div className="gh-image-display">
                {sliderImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`gh-image-item ${index === currentImageSlide ? 'gh-image-active' : ''}`}
                  >
                    <img src={image} alt={`Girls Hostel ${index + 1}`} />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button 
                className="gh-image-nav-btn gh-image-nav-prev"
                onClick={prevSlide}
                aria-label="Previous image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>

              <button 
                className="gh-image-nav-btn gh-image-nav-next"
                onClick={nextSlide}
                aria-label="Next image"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Girls Hostel Facilities Section */}
        <div className="gh-content-section">
          <div className="gh-facilities-container">
            <h3 className="gh-facilities-heading">Our <span className="gh-heading-accent">Facilities</span></h3>
            
            <div className="gh-facilities-grid">
              {facilities.map((facility) => (
                <div 
                  key={facility.id} 
                  className="gh-facility-card"
                >
                  <div className="gh-card-icon">
                    <img src={facility.icon} alt={facility.name} className="gh-item-icon"/>
                  </div>
                  <h4 className="gh-card-title">{facility.name}</h4>
                  <p className="gh-card-desc">{facility.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GirlsHostel;